import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../Components/Header';
import RealTimeGraph from './LiveGraphs';

const DeviceDetails = () => {
  const { id } = useParams(); // Get device ID from URL
  const [deviceData, setDeviceData] = useState({});
  const [connectionStatus, setConnectionStatus] = useState('Connecting...');
  const [location, setLocation] = useState('Unknown');

  useEffect(() => {
    const token = localStorage.getItem('token');
    const placeData = JSON.parse(localStorage.getItem('place') || "[]");

    const foundPlace = placeData.find(device => device.device_id === id);
    if (foundPlace && foundPlace.place) {
      setLocation(foundPlace.place);
    }

    const ws = new WebSocket(`/api/ws/${id}?token=${token}`);

    ws.onopen = () => {
      setConnectionStatus('Connected');
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        setDeviceData(data);
      } catch (error) {
        console.error('Error parsing message:', error);
      }
    };

    ws.onclose = () => {
      setConnectionStatus('Disconnected');
    };

    ws.onerror = (error) => {
      console.error('WebSocket Error:', error);
      setConnectionStatus('Error');
    };

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };
  }, [id]);

  return (
    <>
      <Header />
      <div className="flex px-4 sm:px-6 lg:px-8 py-6">
        <div className="max-w-auto mx-auto bg-white shadow-md rounded-xl p-6">
          <h1 className="text-2xl font-bold text-blue-600 mb-4">Device Details: {id}</h1>
          <p className="text-gray-700 mb-2">Location: <span className="font-medium">{location}</span></p>
          
          <div className="flex gap-4 ">
            <DataItem label="Temperature" value={`${deviceData.temperature || 'N/A'} °C`} />
            <DataItem label="Humidity" value={`${deviceData.relative_humidity || 'N/A'} %`} />
            <DataItem label="Wind Speed" value={`${deviceData.wind_speed } m/s`} />
            <DataItem label="Wind Direction" value={`${deviceData.wind_direction}`} />
            <DataItem label="Baro Pressure" value={`${deviceData.baro_press || 'N/A'} hPa`} />
            <DataItem label="Rain" value={`${deviceData.rain} mm`} />
            <DataItem label="Battery Voltage" value={`${deviceData.battery_voltage || 'N/A'} V`} />
          </div>
        </div>
      </div>
<RealTimeGraph/>
    </>
  );
};

const DataItem = ({ label, value }) => (
  <div className="bg-gray-100 rounded-lg p-4 shadow-sm">
    <p className="text-gray-500 text-sm">{label}</p>
    <p className="text-lg font-semibold text-gray-800">{value}</p>
  </div>
);

export default DeviceDetails;
